import { MetadataManager } from './metadata'
import { UploadDevice } from '@/models/upload-device'
import { UploadData } from '@/models/upload-data'
import Joi from 'joi'

export class UploaddataManager extends MetadataManager {
  constructor (vueComponent) {
    super(vueComponent)

    this._uploadDevice = new UploadDevice()
    this._uploadData = new UploadData()

    this._operationMap = {
      'uploadManager': {
        add: this._addPoint
      },
      'uploadDevice': {
        click: this._inspectUploadDevice,
        edit: this._editUploadDevice,
        remove: this._removeUploadDevice,
        add: this._addUploadData
      },
      'uploadData': {
        click: this._inspectUploadData,
        edit: this._editUploadData,
        remove: this._removeUploadData
      }
    }

    this._addListeners()
  }

  async genTreeData () {
    return [
      {
        id: 'root-node1',
        name: '上报设备',
        operations: [ 'add' ],
        class: 'uploadManager',
        children: await this._genUploadDevices()
      }
    ]
  }

  async _addPoint () {
    this._requestForm('uploadDevice', {
      deviceName: '',
      deviceId: '',
      interval: ''
    })
  }

  async _inspectUploadDevice (device) {
    const data = await this._uploadDevice.get(device.id)

    await this._requestForm('uploadDevice', {
      deviceName: data.dName,
      deviceId: data.dId,
      interval: data.interval
    }, false)
  }

  async _editUploadDevice (device) {
    let data = await this._uploadDevice.get(device.id)

    await this._requestForm('uploadDevice', {
      _id: device.id,
      deviceName: data.dName,
      deviceId: data.dId,
      interval: data.interval
    }, true, 'updateUploadDevice')
  }

  async _removeUploadDevice (device) {
    await this._uploadDevice.delete(device.id)

    this.alertSuccess('删除成功')
  }

  async _addUploadData (device) {
    this._requestForm('uploadData', {
      _id: device.id,
      deviceId: '',
      dataId: '',
      iName: '',
      iId: '',
      iUnit: '',
      devices: await this._genFormDatas()
    })
  }

  async _inspectUploadData (uData) {
    const data = await this._uploadData.get(uData.id)

    await this._requestForm('uploadData', {
      deviceId: data.deviceId,
      dataId: data.dataId,
      iName: data.iName,
      iId: data.iId,
      iUnit: data.iUnit,
      devices: await this._genFormDatas()
    }, false)
  }

  async _editUploadData (uData) {
    let data = await this._uploadData.get(uData.id)

    this._requestForm('uploadData', {
      _id: uData.id,
      deviceId: data.deviceId,
      dataId: data.dataId,
      iName: data.iName,
      iId: data.iId,
      iUnit: data.iUnit,
      devices: await this._genFormDatas()
    }, true, 'updateUploadData')
  }

  async _removeUploadData (uData) {
    await this._uploadData.delete(uData.id)

    this.alertSuccess('删除成功')
  }

  async _genUploadDevices () {
    return Promise.all((await this._uploadDevice.all()).map(async device => {
      return {
        name: device.dName,
        operations: [ 'click', 'remove', 'edit', 'add' ],
        children: await this._genUploadDatas(device.id),
        class: 'uploadDevice',
        id: device.id
      }
    }))
  }

  async _genUploadDatas (id) {
    return (await this._uploadData.all())
      .filter(data => data.uploadDeviceId === id)
      .map(data => {
        return {
          name: data.iName,
          operations: [ 'click', 'remove', 'edit' ],
          class: 'uploadData',
          id: data.id
        }
      })
  }

  _verifyUploadDevice (data) {
    Joi.validate(data, {
      _id: Joi.string(),
      deviceName: Joi.string().required(),
      deviceId: Joi.string().required(),
      interval: Joi.number().required()
    }, err => {
      if (err) throw err
    })
  }

  _verifyUploadData (data) {
    Joi.validate(data, {
      _id: Joi.string(),
      iName: Joi.string().required(),
      iId: Joi.string().required(),
      iUnit: Joi.string().required(),
      deviceId: Joi.string().required(),
      dataId: Joi.string().required()
    }, err => {
      if (err) throw err
    })
  }

  async _addListeners () {
    /* add upload-device */
    this._addFormListener('uploadDevice', async data => {
      this._verifyUploadDevice(data)

      await this._uploadDevice.add({
        dId: data.deviceId,
        dName: data.deviceName,
        interval: data.interval
      })

      this.alertSuccess('保存成功')
    })

    /* edit upload-device */
    this._addListener('updateUploadDevice', async data => {
      this._verifyUploadDevice(data)

      await this._uploadDevice.update(data._id, {
        dId: data.deviceId,
        dName: data.deviceName,
        interval: data.interval
      })

      this.alertSuccess('保存成功')
    })

    /* add upload-data */
    this._addFormListener('uploadData', async data => {
      this._verifyUploadData()

      await this._uploadData.add({
        uploadDeviceId: data._id,
        deviceId: data.deviceId,
        dataId: data.dataId,
        iName: data.iName,
        iId: data.iId,
        iUnit: data.iUnit,
        iCode: ''
      })

      this.alertSuccess('保存成功')
    })

    /* edit upload-data */
    this._addFormListener('updateUploadData', async data => {
      this._verifyUploadData()

      await this._uploadData.update(data._id, {
        deviceId: data.deviceId,
        dataId: data.dataId,
        iName: data.iName,
        iId: data.iId,
        iUnit: data.iUnit
      })

      this.alertSuccess('保存成功')
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/home/controllers/upload-data.js